<script lang="ts">
  import { createMeQuery } from '../shared/auth/auth.svelte';
  import { navigate } from '../shared/router/router.svelte';
  import { ErrorState, PulseLoader } from '../shared/ui';

  /** `/` → onboarding (no org), the only org, or the organization picker. */
  const me = createMeQuery();
  $effect(() => {
    if (!me.data) return;
    const [first, ...rest] = me.data.memberships;
    if (!first) navigate('/onboarding', { replace: true });
    else if (rest.length === 0) navigate(`/o/${first.organization.id}`, { replace: true });
    else navigate('/orgs', { replace: true });
  });
</script>

{#if me.isPending}
  <PulseLoader page />
{:else if me.isError}
  <ErrorState error={me.error} onRetry={() => void me.refetch()} />
{/if}
